// This controller will scroll the associated element into view
// %div{data: {controller:"scroll-into-view"}}
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.scrollIntoView(false);
  }
}
